<template>
  <div>
      <b-modal static id="newEntryModal" ref="newEntryModal" :title="`New Entry`" size="lg" no-close-on-backdrop hide-footer>
        <new-entry ref="newEntryC" @error="displayError" :isAdmin="isAdmin" :newEntry="newEntry" :event="event" :selectedEntryType="selectedEntryType" @cancel="$refs.newEntryModal.hide()" @addEntry="createEntry" @editEntry="editEntry"/>
      </b-modal>
    <b-modal if="editWeight" ref="editWeightModal" title="Edit Declared Weight" size="lg" no-close-on-backdrop hide-footer>
      <div class='flex  justify-center mb-6 items-end'>
        <div class="flex flex-col w-1/2  mx-4">
          <label class="text-lg font-light pb-1">Animal ID: <strong>{{newEntry.entry_details.animal_id}}</strong></label>
          <input class="border p-2 rounded w-full" v-model.number="newEntry.entry_details.weight" type="number">
        </div>
        <button class="btn btn-green" @click="saveWeight">Save</button>
      </div>
      <div class="hr"></div>
      <div class="flex justify-end">
        <button class='btn btn-red' @click="$refs.editWeightModal.hide()">Cancel</button>
      </div>
    </b-modal>
    <!--<b-modal id="updateModal" ref="updateModal" hide-footer title='Edit Entry' no-close-on-backdrop size="lg">
      <edit-entry ref="editEntry" @error="displayError" :isAdmin="isAdmin" :updateEntry="updateEntry" :event="event" :selectedEntryType="selectedEntryType" @cancel="$refs.updateModal.hide()" @editEntry="editEntry"/>
    </b-modal>-->
    <b-modal id="addExhibitorModal" ref="addExhibitorModal" hide-footer title="Update Exhibitor" no-close-on-backdrop size="lg">
      <input type="text" v-model="exhibitor_name" placeholder="Exhibitor's name" class="text-input focus:outline-none focus:shadow-outline">
      <button class="btn btn-blue" @click="updateExhibitor">Update</button>
      <button class="btn btn-red-outline" @click="cancelExhibitorUpdate">Cancel</button>
    </b-modal>
  </div>
</template>

<script>
import NewEntry from '@/components/NewEntry'

import Vue from 'vue'
export default {
  components: {
    NewEntry
    // EditEntry
  },
  props: {
    event: Object,
    isAdmin: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      newEntry: {
        entry_details: {},
        shows: []
      },
      updateEntry: {
        shows: [],
        entry_details: {}
      },
      selectedEntryType: null,
      selectClassType: null,
      exhibitor_name: null,
      entryGroupID: null
    }
  },
  methods: {
    newEntryClicked (type, entryGroupID, userID) {
      this.selectedEntryType = type
      this.$refs.newEntryC.setSelectedEntryType(type)

      this.entryGroupID = entryGroupID
      this.newEntry = {
        entry_details: {},
        entry_group_id: entryGroupID,
        user_id: userID,
        animal: null
      }

      this.$refs.newEntryC.reset()
      if (this.$refs.newEntryC.showList.length === 1) {
        Vue.set(this.newEntry, 'shows', JSON.parse(JSON.stringify(this.$refs.newEntryC.showList)))
      }
      this.$refs.newEntryC.setSectionIndex(0)
      this.$refs.newEntryModal.show()
    },
    createEntry: function () {
      this.$store.dispatch(this.createAction, {
        // TODO: NORMALIZE THE ENTRY TYPE FIELD
        entry_type: this.selectedEntryType.type, // This comes from the show type
        newEntry: this.newEntry,
        entry_group_id: this.entryGroupID,
        class_name: this.newEntry.class_name
      })
        .then(response => {
          this.$refs.newEntryModal.hide()
          this.newEntry = {
            entry_details: {},
            class: null
          }
          this.notie.alert({
            type: 1,
            text: 'Entry Created'
          })
          this.$refs.newEntryC.reset()
        })
        .catch((e) => {
          // this.$honeybadger.notify(error)
          if (e.message.includes('405')) {
            this.notie.alert({
              type: 2,
              time: 7,
              text: `WARNING - Entry Not Added<br>It appears that entries are closed. Please try refreshing the page and re-checking the entry status before trying again.`
            })
          } else {
            this.notie.alert({
              type: 3,
              text: `Error creating entry, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          }
          this.$refs.newEntryC.reset()
          this.$refs.newEntryModal.hide()
        })
    },
    editWeightClicked (entry, entryGroupID) {
      this.newEntry = {...entry}
      this.entryGroupID = entryGroupID

      var shows = []
      if (!entry.shows[0].name) {
        entry.shows.forEach(s => {
          shows.push({
            value: s,
            name: this.showDecode[s].name
          })
        })
      } else {
        entry.shows.forEach(s => {
          shows.push({
            value: s.show_id,
            name: s.name
          })
        })
      }
      this.$set(this.newEntry, 'shows', shows)
      this.$set(this.newEntry, 'exhibitor_id', entry.exhibitor_id)
      this.$refs.editWeightModal.show()
    },
    saveWeight () {
      this.editEntry('Entry Details')
      this.$refs.editWeightModal.hide()
    },
    editEntryClicked (type, entry, entryGroupID, userID) {
      this.selectedEntryType = type
      this.$refs.newEntryC.setSelectedEntryType(type)
      // Hard code for now to go to confirm section
      this.$refs.newEntryC.setSectionIndex(3)

      this.entryGroupID = entryGroupID

      this.newEntry = {...entry}
      var shows = []
      if (!entry.shows[0].name) {
        entry.shows.forEach(s => {
          shows.push({
            value: s,
            name: this.showDecode[s].name
          })
        })
      } else {
        entry.shows.forEach(s => {
          shows.push({
            value: s.show_id,
            name: s.name
          })
        })
      }
      this.$set(this.newEntry, 'shows', shows)
      this.$set(this.newEntry, 'exhibitor_id', entry.exhibitor_id)
      this.newEntry.originalShows = [...entry.shows]
      this.newEntry.user_id = userID
      this.$refs.newEntryModal.show()
    },
    editEntry (type) {
      this.$store.dispatch(this.editAction, {
        type: type,
        updateEntry: this.newEntry,
        entry_group_id: this.entryGroupID
      })
        .then(response => {
          this.notie.alert({
            type: 1,
            text: 'Entry Updated'
          })

          this.$refs.newEntryC.reset()
        })
        .catch((e) => {
          if (e.message.includes('405')) {
            this.notie.alert({
              type: 2,
              time: 7,
              text: `WARNING - Entry Not Updated<br>It appears that either entries for this type are closed or this entry has already been checked in. Please try refreshing the page and re-checking the entry status before trying again.`
            })
          } else {
            this.notie.alert({
              type: 3,
              text: `Error updating entry, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          }
          this.$refs.newEntryC.reset()
        })
    },
    deleteEntry (entry, entryGroupID) {
      this.entryGroupID = entryGroupID
      // this.$store.dispatch(this.deleteAction, {entry: entry, entry_group_id: this.entryGroupID, entry_ids: entryIDs})
      this.$store.dispatch(this.deleteAction, {entry: entry, entry_group_id: this.entryGroupID})
        .then(response => {
          this.notie.alert({
            type: 2,
            text: 'Entry Deleted'
          })
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error deleting entry.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    deleteIndividualEntry (entryID, entryGroupID) {
      this.$store.dispatch('deleteIndividualEntry_admin', {entry_id: entryID, entry_group_id: entryGroupID})
        .then(response => {
          this.notie.alert({
            type: 2,
            text: 'Entry Deleted'
          })
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error deleting entry.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    displayError (errorMsg) {
      this.notie.alert({
        type: 3,
        text: errorMsg
      })
    },
    specifyExhibitorClicked (entry, entryGroupID, userID) {
      this.updateEntry = entry
      this.$refs.addExhibitorModal.show()
    },
    updateExhibitor () {
      Vue.set(this.updateEntry.entry_details, 'exhibitor_name', this.exhibitor_name)
      this.$store.dispatch('updateEntryExhibitor', {
        updateEntry: this.updateEntry
      })
        .then(response => {
          this.exhibitor_name = null
          this.$refs.addExhibitorModal.hide()
        })
        .catch(() => {
          Vue.set(this.updateEntry.entry_details, 'exhibitor_name', '')
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error updating exhibitor, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    cancelExhibitorUpdate () {
      this.exhibitor_name = null
      this.$refs.addExhibitorModal.hide()
    }
  },
  computed: {
    createAction () {
      if (this.isAdmin) {
        return 'createEntry_admin'
      } else {
        return 'createEntry'
      }
    },
    editAction () {
      if (this.isAdmin) {
        return 'editEntry_admin'
      } else {
        return 'editEntry'
      }
    },
    deleteAction () {
      if (this.isAdmin) {
        return 'deleteEntry_admin'
      } else {
        return 'deleteEntry'
      }
    },
    showDecode () {
      var obj = {}
      if (this.event) {
        this.event.shows.forEach(s => {
          obj[s.show_id] = s
        })
      }
      return obj
    }
  }
}
</script>

<style>

</style>
